export enum Permission {
    // Authentication
    AUTH_REGISTER = 'AUTH_REGISTER',

    // User management
    USER_MANAGE = 'USER_MANAGE',
    TENANT_MANAGE = 'TENANT_MANAGE',
    USER_ACCESS_SCREEN = 'USER_ACCESS_SCREEN',
    USER_CODE_DATA = 'USER_CODE_DATA',

    // Projects
    PROJECT_MANAGE = 'PROJECT_MANAGE',
    PROJECT_READ = 'PROJECT_READ',
    PROJECT_DELETE = 'PROJECT_DELETE',
    PROJECT_ACCESS_SCREEN = 'PROJECT_ACCESS_SCREEN',
    PROJECT_EDIT_INITIAL_COST = 'PROJECT_EDIT_INITIAL_COST',

    // Technologies
    TECHNOLOGY_MANAGE = 'TECHNOLOGY_MANAGE',
    TECHNOLOGY_ACCESS_SCREEN = 'TECHNOLOGY_ACCESS_SCREEN',

    // Catalogs
    CATALOG_MANAGE = 'CATALOG_MANAGE',
    CATALOG_READ = 'CATALOG_READ',
    CATALOG_EDIT_CONFIG = 'CATALOG_EDIT_CONFIG',
    CATALOG_ACCESS_SCREEN = 'CATALOG_ACCESS_SCREEN',

    // Profiles
    PROFILE_MANAGE = 'PROFILE_MANAGE',
    PROFILE_READ = 'PROFILE_READ',
    PROFILE_ACCESS_SCREEN = 'PROFILE_ACCESS_SCREEN',
    PROFILE_CODE_DATA = 'PROFILE_CODE_DATA',

    // Estimates
    ESTIMATE_WRITE = 'ESTIMATE_WRITE',
    ESTIMATE_READ = 'ESTIMATE_READ',
    ESTIMATE_DELETE = 'ESTIMATE_DELETE',
    ESTIMATE_CERTIFY = 'ESTIMATE_CERTIFY',
    ESTIMATE_REVIEW = 'ESTIMATE_REVIEW',
    ESTIMATE_ACCESS_SCREEN = 'ESTIMATE_ACCESS_SCREEN',
    ESTIMATE_SUMARY_ACCESS_SCREEN = 'ESTIMATE_SUMARY_ACCESS_SCREEN',
    ESTIMATE_APPROVE = 'ESTIMATE_APPROVE',
    ESTIMATE_REJECT = 'ESTIMATE_REJECT',
    ESTIMATE_CLOSE = 'ESTIMATE_CLOSE',
    ESTIMATE_TO_FIX = 'ESTIMATE_TO_FIX',
    ESTIMATE_IMPUTATION_WRITE = 'ESTIMATE_IMPUTATION_WRITE',

    // Imputations
    IMPUTATION_READ = 'IMPUTATION_READ',
    ESTIMATE_IMPUTATION_READ = 'ESTIMATE_IMPUTATION_READ',
}

